import React, { cloneElement } from 'react';
import { Link } from 'react-router-dom';
import { Users2Icon, BabyIcon, HeartHandshakeIcon, ShieldAlertIcon, Building2Icon, UserCheckIcon } from 'lucide-react';
export function TargetClients() {
  const clients = [{
    name: 'Individuals & Families',
    icon: <Users2Icon data-id="element-186" />
  }, {
    name: 'Youth & Adolescents',
    icon: <BabyIcon data-id="element-187" />
  }, {
    name: 'Couples & Married Partners',
    icon: <HeartHandshakeIcon data-id="element-188" />
  }, {
    name: 'Veterans & Trauma Survivors',
    icon: <ShieldAlertIcon data-id="element-189" />
  }, {
    name: 'Healthcare Patients',
    icon: <UserCheckIcon data-id="element-190" />
  }, {
    name: 'Employers & Organizations',
    icon: <Building2Icon data-id="element-191" />
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="text-center mb-16" data-id="element-194">
          <h2 className="text-brand-red font-bold tracking-wider uppercase text-sm mb-4" data-id="element-195">
            Who We Serve
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold text-brand-navy" data-id="element-196">
            Dedicated Support for Every Journey
          </h3>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {clients.map(client => <div key={client.name} className="flex items-center p-6 bg-brand-light rounded-2xl border border-gray-100 hover:border-brand-red/30 transition-colors" data-id="element-198">
              <div className="p-3 bg-white rounded-xl shadow-sm text-brand-red mr-4" data-id="element-199">
                {cloneElement(client.icon as React.ReactElement, {
              className: 'h-6 w-6'
            })}
              </div>
              <span className="font-bold text-brand-navy" data-id="element-200">{client.name}</span>
            </div>)}
        </div>

        <div className="mt-16 bg-brand-red rounded-3xl p-8 lg:p-12 text-white flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-201">
          <div className="max-w-2xl" data-id="element-202">
            <h4 className="text-2xl lg:text-3xl font-bold mb-4" data-id="element-203">
              Ready to reclaim your health and purpose?
            </h4>
            <p className="text-white/90 text-lg" data-id="element-204">
              Join the many individuals and families who have found restoration
              through our integrated approach.
            </p>
          </div>
          <Link to="/contact" className="bg-brand-navy text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-white hover:text-brand-navy transition-all whitespace-nowrap shadow-xl" data-id="element-205">
            Schedule a Call
          </Link>
        </div>
      </div>
    </section>;
}